import { isAppsInTossChannel } from './lib/channel';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { LocalStateProvider } from './state/LocalStateProvider';
import './styles/tokens.css';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element is missing');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <LocalStateProvider>
        <App />
      </LocalStateProvider>
    </BrowserRouter>
  </StrictMode>,
);

if (!isAppsInTossChannel() && 'serviceWorker' in navigator) window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => undefined); });
